import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { AppInsightsService } from '../../services/appinsights/appinsights.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { LocaleComponent } from '../Locale/locale.component';

@Component({
    standalone: true,
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'prompt-component',
    templateUrl: './prompt.component.html',
    imports: [CdkScrollable, MatDialogContent, LocaleComponent]
})
export class PromptComponent {
  view: string;
  constructor(
    public dialogRef: MatDialogRef<PromptComponent>, private appInsightsService: AppInsightsService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.view = data.localeView;
    this.appInsightsService.logPageView('PromptComponent');
    
  }

  onContinueOptAction(continues:boolean){
    this.dialogRef.close(continues);
    this.appInsightsService.logEvent(`closed prompt restriction, customer continue with worflow ${continues}`);
  }
}
